/**
 * Internal dependencies
 */
import { addFilterCollabBlockSelection } from './block-selection';
export const addCollabFilters = () => {
  addFilterCollabBlockSelection();
};
//# sourceMappingURL=index.js.map